(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["florae-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('florae-announcement')) {
  customElements.define('florae-announcement', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.florae-ticker__pause');
      if (!button) return;
      button.onclick = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
      };
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florae-deuil-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-gerbe-size]')) return;
  const card = event.target.closest('[data-florae-gerbe]');
  const link = card.querySelector('[data-gerbe-quote]');
  if (!link) return;
  const url = new URL(link.dataset.base, window.location.origin);
  url.searchParams.set('text', 'Bonjour Florae, je souhaite un devis pour ' + card.dataset.title + ', composition ' + event.target.value + '.');
  link.href = url.href;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florae-header"]) return;
  try {
    
document.addEventListener('click', event => {
  document.querySelectorAll('.florae-header__dropdown[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.florae-header details[open]').forEach(menu => {
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    menu.removeAttribute('open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florae-plant-care"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('florae-care')) {
  customElements.define('florae-care', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const list = this.querySelector('[data-list]');
      const rows = Array.from(list.querySelectorAll('[data-name]'));
      const collator = new Intl.Collator('fr', { sensitivity: 'base', numeric: true });
      rows.sort((a, b) => collator.compare(a.dataset.name, b.dataset.name)).forEach(row => list.append(row));
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const input = this.querySelector('input');
      const status = this.querySelector('[data-count]');
      const filter = () => {
        const query = normalize(input.value);
        let count = 0;
        rows.forEach(row => { row.hidden = !normalize(row.dataset.name).includes(query); if (!row.hidden) count++; });
        status.textContent = status.dataset.pattern.replace('{count}', count);
        this.querySelector('[data-empty]').hidden = count !== 0;
      };
      input.addEventListener('input', filter);
      this.querySelector('.florae-care__search').hidden = false;
      filter();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florae-product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[id^="FloraeVariant-"]')) return;
    const section = event.target.closest('.florae-product');
    const option = event.target.selectedOptions[0];
    const price = section.querySelector('[id^="FloraePrice-"]');
    const mobilePrice = section.querySelector('.florae-product__mobile-bar span');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (mobilePrice && option.dataset.price) mobilePrice.textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florae-seasonal-calendar"] && !Shopify.designMode) return;
  try {
    
function initFloraeCalendar(root) {
  root.querySelectorAll('[data-florae-seasonal]').forEach((section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const tabs = [...section.querySelectorAll('[data-month-tab]')];
    const panels = [...section.querySelectorAll('[data-month-panel]')];
    const open = (month) => {
      if (!panels.some(panel => panel.dataset.monthPanel === month) && tabs[0]) month = tabs[0].dataset.monthTab;
      tabs.forEach(tab => {
        const active = tab.dataset.monthTab === month;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => {
        const active = panel.dataset.monthPanel === month;
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
    };
    section.openFloraeMonth = open;
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => open(tab.dataset.monthTab));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        open(tabs[target].dataset.monthTab);
        tabs[target].focus();
      });
    });
    panels.forEach(panel => {
      const main = panel.querySelector('[data-seasonal-main]');
      const rows = [...panel.querySelectorAll('[data-flower-row]')];
      const select = index => {
        const template = rows[index]?.querySelector('[data-full-image]');
        if (template && main) main.replaceChildren(template.content.cloneNode(true));
        rows.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          item.setAttribute('aria-pressed', String(i === index));
        });
      };
      rows.forEach((row, index) => row.addEventListener('click', () => select(index)));
      select(0);
    });
    open(section.dataset.currentMonth);
  });
}
initFloraeCalendar(document);
document.addEventListener('shopify:section:load', event => initFloraeCalendar(event.target));
document.addEventListener('shopify:block:select', event => {
  const tab = event.target.closest('[data-month-tab]');
  const calendar = tab?.closest('[data-florae-seasonal]');
  if (calendar?.openFloraeMonth) calendar.openFloraeMonth(tab.dataset.monthTab);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florae-stem-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const text=JSON.parse(root.querySelector('[data-builder-text]').textContent);
    const cards=[...root.querySelectorAll('[data-flower]')];
    const button=root.querySelector('[data-submit]');
    const status=root.querySelector('[data-status]');
    const money=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:root.dataset.currency||'EUR'});
    const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/œ/g,'oe').toLowerCase();
    let busy=false;
    function selected(){return cards.map(card=>({card,id:Number(card.dataset.variant),name:card.dataset.name,price:Number(card.dataset.price),quantity:Math.max(0,Math.min(99,Math.floor(Number(card.querySelector('input').value)||0))),image:card.dataset.image})).filter(x=>x.quantity>0);}
    function update(){
      const items=selected(),count=items.reduce((s,x)=>s+x.quantity,0),total=items.reduce((s,x)=>s+x.quantity*x.price,0);
      root.querySelector('[data-total-count]').textContent=count;
      root.querySelector('[data-total-price]').textContent=money.format(total/100);
      button.disabled=busy||count===0;
      const list=root.querySelector('[data-selection]');list.replaceChildren();
      items.forEach(x=>{const li=document.createElement('li'),name=document.createElement('span'),price=document.createElement('span');name.textContent=x.quantity+' × '+x.name;price.textContent=money.format(x.quantity*x.price/100);li.append(name,price);list.append(li);});
      cards.forEach(card=>{const input=card.querySelector('input'),n=Math.max(0,Math.min(99,Math.floor(Number(input.value)||0)));input.value=n;card.querySelector('[data-delta="-1"]').disabled=input.disabled||n===0;card.querySelector('[data-delta="1"]').disabled=input.disabled||n===99;});
      const svg=root.querySelector('[data-stems]'),blossoms=root.querySelector('[data-blossoms]');svg.replaceChildren();blossoms.replaceChildren();
      const max=48;let visual=[];items.forEach(x=>{for(let j=0;j<x.quantity;j++)visual.push(x);});
      if(visual.length>max){const all=visual;visual=Array.from({length:max},(_,i)=>all[Math.floor(i*all.length/max)]);}
      visual.forEach((x,i)=>{const angle=i*2.39996,r=Math.sqrt((i+.5)/visual.length)*125,px=200+Math.cos(angle)*r,py=115+Math.sin(angle)*r*.63;const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d',`M ${px} ${py} Q ${200+(px-200)*.2} 235 ${200+(i%7-3)*3} 304`);path.setAttribute('stroke','#9aab70');path.setAttribute('stroke-width','2');path.setAttribute('fill','none');svg.append(path);const img=document.createElement('img');img.src=x.image;img.alt='';img.className='florae-builder__bloom';img.style.left=px/4+'%';img.style.top=py/3.3+'%';img.style.width=Math.max(12,28-visual.length*.25)+'%';blossoms.append(img);});
    }
    cards.forEach(card=>{card.querySelectorAll('[data-delta]').forEach(b=>b.addEventListener('click',()=>{const input=card.querySelector('input');input.value=Number(input.value)+Number(b.dataset.delta);update();}));card.querySelector('input').addEventListener('change',update);});
    root.querySelector('[data-flower-search]').addEventListener('input',e=>{const term=normalize(e.target.value);let found=0;cards.forEach(card=>{card.hidden=!normalize(card.dataset.name).includes(term);if(!card.hidden)found++;});root.querySelector('[data-no-results]').hidden=found>0;});
    button.addEventListener('click',async()=>{
      const items=selected();if(busy||!items.length)return;
      busy=true;update();button.textContent=text.loading;status.textContent='';
      const group='FL-'+Date.now().toString(36).toUpperCase();
      const message=root.querySelector('[data-message]').value.trim();
      const properties={[text.composition]:group};if(message)properties[text.message]=message;
      try{
        const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items.map(x=>({id:x.id,quantity:x.quantity,properties}))})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||text.error);
        status.textContent=text.success;root.querySelector('[data-cart-link]').hidden=false;
        window.location.assign(root.dataset.cartUrl);
      }catch(error){status.textContent=error.message||text.error;root.querySelector('[data-cart-link]').hidden=false;busy=false;button.textContent=text.button;update();}
    });update();
  }
  document.querySelectorAll('[data-stem-builder]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-stem-builder]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
